var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

export default isNumeric;
//# sourceMappingURL=isNumeric.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/_util/isNumeric.js
// module id = 737
// module chunks = 0